import request from "../utils/request.js"
// 获取需求列表
export function getDemandList(params, value) {
    let url
    if (value) {
        url = "/demand/demandList?value=" + value
    } else {
        url = "/demand/demandList"
    }
    return request({
        url: url,
        method: "post",
        data: params,
    })
}
// 发布需求
export function saveDemand(params) {
    return request({
        url: "/demand/saveDemand",
        method: "post",
        data: params,
    })
}
// 获取需求类型列表
export function getDemandType() {
    return request({
        url: "/demand/getDemandType",
        method: "get",
    })
}
// 获取单位类型列表
export function getPriceCompanyType() {
    return request({
        url: "/demand/getPriceCompanyType",
        method: "get",
    })
}
// 获取需求详情
export function getDemandDetail(params) {
    return request({
        url: "/demand/detail/"+params,
        method: "get"
    })
}
// 删除需求
export function deleteDemand(id) {
    return request({
        url: "/demand/removeDemand/"+id,
        method: "post"
    })
}
